import React, { useEffect, useState } from "react";
import { useSubheader } from "../../../_metronic/layout";
import { Checkbox, Paper, Table, TableBody, TableCell, TableRow, TablePagination, IconButton, Chip, Tooltip, TableHead } from "@material-ui/core";
import { Badge } from "react-bootstrap";
import EnhancedTableHead from "../../components/EnhancedTableHead";
import makeRequest from "../../api/makeRequest";
import { useTranslation } from "react-i18next";
import { Visibility as VisibilityIcon } from "@material-ui/icons";
import moment from "moment-jalaali";
import MyModal from "../../components/MyModal";
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip as ChartTooltip,
	Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	ChartTooltip,
	Legend
);

export const RoomAttendancePage = ({ match }) => {
	const { t } = useTranslation('common');
	const headRows = [
		{ id: "id", disablePadding: true, label: t('Row') },
		{ id: "name", disablePadding: false, label: t('Name') },
		{ id: "firstLogin", disablePadding: false, label: t('FirstLogin') },
		{ id: "lastLogout", disablePadding: false, label: t('LastLogout') },
		{ id: "totalTime", disablePadding: false, label: t('TotalTime') },
		{ id: "connections", disablePadding: false, label: t('Connections') },
		{ id: "percent", disablePadding: false, label: t('AttendancePercent') },
		{ id: "operation", disablePadding: false, label: t('Operations') }
	];
	const suhbeader = useSubheader();
	suhbeader.setTitle(t('Attendance'));

	const [Connections, setConnections] = useState([])
	const [selectedUser, setSelectedUser] = useState(null)
	const [selectedUserConnections, setSelectedUserConnections] = useState(null)
	const [selected, setSelected] = React.useState([]);
	const [orderBy, setOrderBy] = React.useState("_id");
	const [order, setOrder] = React.useState("desc");
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(25);
	const [totalDocs, setTotalDocs] = React.useState(0);

	const [search] = useState({})

	useEffect(() => {
		moment.loadPersian();
	}, [])
	useEffect(() => {
		const getRoomAttendance = async () => {
			try {
				const query = {
					page: page + 1,
					per_page: rowsPerPage
				}
				const { data } = await makeRequest('getRoomAttendance', { id: match.params.sid, search }, query)
				const attendees = data.connections.attendees || []
				
				setConnections(attendees)
				setTotalDocs(data.connections.totalDocs)
			} catch (e) {
				console.log(e)
			}
		}

		getRoomAttendance()

	}, [page, rowsPerPage, match, search])



	function handleSelectAllClick(event) {
		if (event.target.checked) {
			const newSelecteds = Connections.map(n => n.name);
			setSelected(newSelecteds);
			return;
		}
		setSelected([]);
	}

	function handleRequestSort(event, property) {
		const isDesc = orderBy === property && order === "desc";
		setOrder(isDesc ? "asc" : "desc");
		setOrderBy(property);
	}

	function stableSort(array, cmp) {
		const stabilizedThis = array.map((el, index) => [el, index]);
		stabilizedThis.sort((a, b) => {
			const order = cmp(a[0], b[0]);
			if (order !== 0) return order;
			return a[1] - b[1];
		});
		return stabilizedThis.map(el => el[0]);
	}

	function desc(a, b, orderBy) {
		if (b[orderBy] < a[orderBy]) {
			return -1;
		}
		if (b[orderBy] > a[orderBy]) {
			return 1;
		}
		return 0;
	}

	function getSorting(order, orderBy) {
		return order === "desc"
			? (a, b) => desc(a, b, orderBy)
			: (a, b) => -desc(a, b, orderBy);
	}

	const isSelected = name => selected.indexOf(name) !== -1;

	function handleClick(event, name) {
		const selectedIndex = selected.indexOf(name);
		let newSelected = [];

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(selected, name);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(selected.slice(1));
		} else if (selectedIndex === selected.length - 1) {
			newSelected = newSelected.concat(selected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				selected.slice(0, selectedIndex),
				selected.slice(selectedIndex + 1)
			);
		}

		setSelected(newSelected);
	}

	const emptyRows =
		rowsPerPage - Math.min(rowsPerPage, Connections.length - page * rowsPerPage);

	function handleChangePage(event, newPage) {
		setPage(newPage);
	}

	function handleChangeRowsPerPage(event) {
		setPage(0)
		setRowsPerPage(parseInt(event.target.value, 10));
	}

	// Format seconds to HH:MM:SS or MM:SS
	const formatDuration = (seconds) => {
		if (!seconds || seconds === 0) return '00:00';
		const hours = Math.floor(seconds / 3600);
		const minutes = Math.floor((seconds % 3600) / 60);
		const secs = Math.floor(seconds % 60);
		
		if (hours > 0) {
			return `${hours}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
		}
		return `${minutes}:${String(secs).padStart(2, '0')}`;
	};

	function random_rgba() {
		var o = Math.round, r = Math.random, s = 255;
		//+ ',' + r().toFixed(1)
		return 'rgba(' + o(r() * s) + ',' + o(r() * s) + ',' + o(r() * s) + ', 0.6)';
	}

	const handleSelectAttendance = (row) => {
		const options = {
			responsive: true,
			plugins: {
				legend: {
					position: 'top',
				},
				title: {
					display: true,
					text: t('Attendance'),
				},
			},
		};

		const labels = [`${t('Connections')}(${t('Minutes')})`];

		const data = {
			labels,
			datasets: (row?.userSessionInfo?.durations || []).map((q, k) => ({
				label: `${t('Connection')} ${k + 1}`,
				data: [(q / 60).toFixed(1)],
				backgroundColor: random_rgba(),
			}))
		};
		row.options = options;
		row.data = data;
		setSelectedUser(row);
	}

	const handleCloseModal = () => {
		setSelectedUser(null)
	}

	const handleShowConnectionHistory = (row) => {
		setSelectedUserConnections(row);
	}

	return (
		<>
			<MyModal
				active={selectedUser}
				onClose={handleCloseModal}
				header={
					<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
						<span>{t('UserAttendance', { name: selectedUser?.user?.name })}</span>
						{selectedUser?.user?.guest && (
							<Badge bg="secondary" style={{ fontSize: '0.75rem' }}>{t('Guest')}</Badge>
						)}
					</div>
				}
			>
				{selectedUser ?
					<div className="text-center">
						<div style={{ 
							display: 'grid', 
							gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
							gap: '15px', 
							marginBottom: '25px',
							padding: '15px'
						}}>
							<div style={{ 
								background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
								padding: '20px',
								borderRadius: '10px',
								color: 'white',
								boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
							}}>
								<div style={{ fontSize: '0.85rem', opacity: 0.9, marginBottom: '5px' }}>{t('AttendancePercent')}</div>
								<div style={{ fontSize: '2rem', fontWeight: 'bold', cursor: 'pointer' }}>
									{selectedUser.userSessionInfo.AttendancePercent !== null ? 
										`${selectedUser.userSessionInfo.AttendancePercent.toFixed(1)}%` : 
										t('InProgress')
									}
								</div>
							</div>
							
							<div style={{ 
								background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
								padding: '20px',
								borderRadius: '10px',
								color: 'white',
								boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
							}}>
								<div style={{ fontSize: '0.85rem', opacity: 0.9, marginBottom: '5px' }}>{t('TotalTime')}</div>
								<div style={{ fontSize: '1.5rem', fontWeight: 'bold', cursor: 'pointer' }}>{formatDuration(selectedUser.userSessionInfo.totalSec)}</div>
								<div style={{ fontSize: '0.75rem', opacity: 0.8 }}>({(selectedUser.userSessionInfo.totalSec / 60).toFixed(1)} {t('Minutes')})</div>
							</div>
							
							<div style={{ 
								background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
								padding: '20px',
								borderRadius: '10px',
								color: 'white',
								boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
							}}>
								<div style={{ fontSize: '0.85rem', opacity: 0.9, marginBottom: '5px' }}>{t('Connections')}</div>
								<div style={{ fontSize: '2rem', fontWeight: 'bold', cursor: 'pointer' }}>{selectedUser.userSessionInfo.totalConnection}</div>
							</div>
						</div>
						
						<div style={{ marginTop: '20px' }}>
							<h5 style={{ marginBottom: '15px', color: '#464E5F' }}>{t('ConnectionDurations')}</h5>
							<Bar options={selectedUser.options} data={selectedUser.data} />
						</div>
					</div>
					: ''}
			</MyModal>
			
			{/* Connection History Modal */}
			<MyModal open={selectedUserConnections} handleClose={() => setSelectedUserConnections(null)}>
				{selectedUserConnections ? 
					<div style={{ minWidth: '600px' }}>
						<div style={{ marginBottom: '20px' }}>
							<h4 style={{ margin: 0, marginBottom: '5px' }}>
								{t('ConnectionHistory')}
							</h4>
							<div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#7E8299' }}>
								<span>{selectedUserConnections?.user?.name}</span>
								{selectedUserConnections?.user?.guest && (
									<Badge bg="secondary" style={{ fontSize: '0.7rem' }}>{t('Guest')}</Badge>
								)}
							</div>
						</div>
						
						{/* Connection History Table */}
						<div style={{ maxHeight: '500px', overflowY: 'auto' }}>
							<Table size="small">
								<TableHead>
									<TableRow>
										<TableCell align="center" style={{ fontWeight: 'bold', cursor: 'pointer' }}>{t('Row')}</TableCell>
										<TableCell align="center" style={{ fontWeight: 'bold', cursor: 'pointer' }}>{t('JoinedAt')}</TableCell>
										<TableCell align="center" style={{ fontWeight: 'bold', cursor: 'pointer' }}>{t('LeftAt')}</TableCell>
										<TableCell align="center" style={{ fontWeight: 'bold', cursor: 'pointer' }}>{t('Duration')}</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{(selectedUserConnections?.connections || []).map((conn, idx) => {
										const startTime = conn.start_time ? new Date(conn.start_time) : null;
										const endTime = conn.end_time ? new Date(conn.end_time) : null;
										const durationSec = startTime && endTime ? (endTime - startTime) / 1000 : 0;
										
										return (
											<TableRow key={idx} hover>
												<TableCell align="center">{idx + 1}</TableCell>
												<TableCell align="center">
													{startTime ? moment(startTime).format("jYYYY/jMM/jDD HH:mm:ss") : "-"}
												</TableCell>
												<TableCell align="center" style={{ color: !endTime ? '#1BC5BD' : 'inherit', fontWeight: !endTime ? 'bold' : 'normal' }}>
													{endTime ? moment(endTime).format("jYYYY/jMM/jDD HH:mm:ss") : "🟢 " + t('Online')}
												</TableCell>
												<TableCell align="center" style={{ fontFamily: 'monospace', fontWeight: 'bold', cursor: 'pointer' }}>
													{formatDuration(durationSec)}
												</TableCell>
											</TableRow>
										);
									})}
									{(!selectedUserConnections?.connections || selectedUserConnections.connections.length === 0) && (
										<TableRow>
											<TableCell colSpan={4} align="center" style={{ padding: '20px', color: '#7E8299' }}>
												{t('NoData')}
											</TableCell>
										</TableRow>
									)}
								</TableBody>
							</Table>
						</div>
					</div>
					: ''}
			</MyModal>
			{/* <div className="new-room">
				<Link to={'/room/new'}><Button variant="outline-primary mb-5">{t('MENU.NEW')}</Button></Link>
			</div> */}
			{/* <SearchInputs
				onSearch={(e)=>{
					setSearch(e)
					setRequestSearch(prev=>!prev)
				}}
				showReset={JSON.stringify(search) !== "{}"}
			/> */}
			<Paper className={"classes.paper"}>
				<div className={"tableWrapper"}>
					<Table
						className={"classes.table"}
						aria-labelledby="tableTitle"
						size={"medium"}
					>
						<EnhancedTableHead
							numSelected={selected.length}
							order={order}
							orderBy={orderBy}
							onSelectAllClick={handleSelectAllClick}
							onRequestSort={handleRequestSort}
							rowCount={Connections.length}
							headRows={headRows}
						/>
						<TableBody>
							{stableSort(Connections, getSorting(order, orderBy))
								.map((row, index) => {
									const rowId = row?.user?.id + index
									const isItemSelected = isSelected(rowId);
									const labelId = `enhanced-table-checkbox-${index}`;
									// let roleNameKey = '';
									// switch(row?.objectUser?.role){
									// 	case 1:
									// 		roleNameKey = 'StudentRole'
									// 		break;
									// 	case 2:
									// 		roleNameKey = 'ProviderRole'
									// 		break;
									// 	case 3:
									// 		roleNameKey = 'MasterRole'
									// 		break;
									// 	case 4:
									// 		roleNameKey = 'AdminRole'
									// 		break;
									// }

								// Use backend-calculated values (all pre-calculated by API)
							// attendancePercent is null for active sessions
							const AttendancePercent = row.attendancePercent !== null && row.attendancePercent !== undefined ? row.attendancePercent : null;
								// Prepare userSessionInfo for the modal
								const rowConnections = (row?.connections || []).filter(q => q && q.end_time);
								const userSessionInfo = {
									totalConnection: row.totalConnections || 0,
									totalSec: row.totalConnectionTime || 0,
									durations: [],
									AttendancePercent: AttendancePercent
								};
								
								// Calculate individual connection durations for the chart
								rowConnections.forEach(q => {
									const durationOfQ = ((+ new Date(q.end_time)) - (+ new Date(q.start_time))) / 1000;
									userSessionInfo.durations.push(durationOfQ);
								});

								row.userSessionInfo = userSessionInfo;

							return (
								<TableRow
									hover
									onClick={event => handleClick(event, rowId)}
									role="checkbox"
									aria-checked={isItemSelected}
									tabIndex={-1}
									key={rowId}
									selected={isItemSelected}
								>
									<TableCell padding="checkbox">
												<Checkbox
													checked={isItemSelected}
													inputProps={{
														"aria-labelledby": labelId
													}}
												/>
											</TableCell>
											<TableCell
												component="th"
												id={labelId}
												align="center"
											>
											<span style={{ fontFamily: 'monospace', fontSize: '1em', fontWeight: 'bold', color: '#3F4254' }}>{page * rowsPerPage + index + 1}</span>
										</TableCell>
									<TableCell align="center">
										<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
											<span>{row?.user?.name || "Unknown"}</span>
											{row?.user?.guest && (
												<Chip 
													label={t('Guest')} 
													size="small" 
													color="default"
													style={{ height: '20px', fontSize: '0.7rem', backgroundColor: '#e0e0e0' }}
												/>
											)}
										</div>
									</TableCell>
									<TableCell align="center">
										<Tooltip title={row?.firstLoginAt ? moment.unix(row.firstLoginAt).format("jYYYY/jMM/jDD HH:mm:ss") : "-"}>
											<span style={{ cursor: 'help' }}>
												{row?.firstLoginAt ? moment.unix(row.firstLoginAt).format("HH:mm jMM/jDD") : "-"}
											</span>
										</Tooltip>
									</TableCell>
									<TableCell align="center">
										<Tooltip title={row?.lastLogoutAt ? moment.unix(row.lastLogoutAt).format("jYYYY/jMM/jDD HH:mm:ss") : t('StillOnline')}>
											<span style={{ cursor: 'help', color: !row?.lastLogoutAt ? '#1BC5BD' : 'inherit', fontWeight: !row?.lastLogoutAt ? 'bold' : 'normal' }}>
												{row?.lastLogoutAt ? moment.unix(row.lastLogoutAt).format("HH:mm jMM/jDD") : "🟢 " + t('Online')}
											</span>
										</Tooltip>
									</TableCell>
									<TableCell align="center">
										<Tooltip title={`${(row.totalConnectionTime / 60).toFixed(1)} ${t('Minutes')}`}>
											<span style={{ fontWeight: 'bold', fontFamily: 'monospace', cursor: 'help' }}>
												{formatDuration(row.totalConnectionTime)}
											</span>
										</Tooltip>
									</TableCell>
									<TableCell align="center">
										<Chip 
											label={row.totalConnections || 0} 
											size="small"
											color="primary"										onClick={() => handleShowConnectionHistory(row)}											style={{ height: '24px', minWidth: '32px', fontWeight: 'bold', cursor: 'pointer' }}
										/>
									</TableCell>
										{/* <TableCell align="center">{t(roleNameKey)}</TableCell> */}
										<TableCell align="center">
											{AttendancePercent !== null ? (
												<Tooltip title={`${AttendancePercent.toFixed(2)}%`}>
													<Chip
														label={`${AttendancePercent.toFixed(1)}%`}
														size="medium"
														style={{
															fontWeight: 'bold',
															fontSize: '0.95rem',
															minWidth: '70px',
															backgroundColor: AttendancePercent >= 80 ? '#C9F7F5' : 
																AttendancePercent >= 60 ? '#E1E9FF' : 
																AttendancePercent >= 40 ? '#FFF4DE' : '#FFE2E5',
															color: AttendancePercent >= 80 ? '#0BB783' : 
																AttendancePercent >= 60 ? '#3699FF' : 
																AttendancePercent >= 40 ? '#FFA800' : '#F64E60',
															cursor: 'help'
														}}
													/>
												</Tooltip>
											) : (
												<Chip
													label={t('InProgress')}
													size="medium"
													style={{
														fontWeight: 'bold',
														fontSize: '0.95rem',
														minWidth: '70px',
														backgroundColor: '#E1F0FF',
														color: '#187DE4'
													}}
												/>
											)}
										</TableCell>
											<TableCell align="center">
												<IconButton onClick={() => handleSelectAttendance(row)} color="primary" component="span">
													<VisibilityIcon />
												</IconButton>
											</TableCell>
										</TableRow>
									);
								})}
							{emptyRows > 0 && (
								<TableRow style={{ height: 49 * 5 }}>
									<TableCell colSpan={9} />
								</TableRow>
							)}
						</TableBody>
					</Table>
				</div>
				<TablePagination
					rowsPerPageOptions={[5, 10, 25, 50, 100]}
					component="div"
					labelRowsPerPage={t('NumberPerPage')}
					count={totalDocs}
					rowsPerPage={rowsPerPage}
					page={page}
					backIconButtonProps={{
						"aria-label": "Previous Page"
					}}
					nextIconButtonProps={{
						"aria-label": "Next Page"
					}}
					onChangePage={handleChangePage}
					onChangeRowsPerPage={handleChangeRowsPerPage}
				/>
			</Paper>
		</>
	);
};